<template>
  <div class="home page">
    <div class="wrapper">
      <div class="home-inner container">
        <h1 class="title movie-title" style="text-align: center;" v-if="cinema">{{ cinema.data.cinemaName }}</h1>
        <h2 class="title movie-title">{{ $t('movie.schedule') }}</h2>
        <div class="movie-container">
          <MovieSwiper :movies="movies" @slideChange="updateSelectedMovie"></MovieSwiper><!-- mobile version only -->
          <div class="movie-schedule">
            <div class="movie-schedule-head">
              <div v-if="movies.length" class="movie-schedule-info">
                <h2 class="text-center">{{ movies[swiperIndex].text }}</h2>
                <p class="text-center"><label class="info">
                  <template v-for="(tag, idx) in movies[swiperIndex].tag">
                    <template v-if="idx !== 0">/</template>
                    {{ tag }}
                  </template>
                </label></p>
                <p class="text-center"></p>
              </div>
              <CalendarHead :window-width="windowWidth" :parentDateClickHandler="onDateChange"></CalendarHead>
            </div>
            <div class="loader" v-if="isLoading"></div>
            <div v-if="movies.length" class="movie-schedule-body">
              <template  v-if="windowWidth > mobileWidth">
                <div v-for="(movie, idx) in movies" :key="idx" class="movie-schedule-item">
                  <span style="font-weight: 700;font-size: 20px;margin-right: 10px;">{{ movie.text }}</span>
                  <label v-if="movie.category !== 'なし'" class="info" style="font-size: 20px">{{ movie.category }}</label>
                  <div class="schedule-container">
                      <div class="image" :class="{ 'full-height': movie.schedules.length === 2 }">
                        <img :src="movie.image"/>
                      </div>
                  <div class="schedule">
                  <table class="schedule-table">
                  <tbody v-for="(schedule, j) in movie.schedules" :key="`movie-${idx}-schedule-${j}`">

                    <tr v-for="item in schedule.rowspan" :key="item">
                      <!-- <td class="image" :class="{ 'full-height': movie.schedules.length === 2 }" v-if="j === 0" :rowspan="movie.needSpan">
                        <img :src="movie.image"/>
                      </td> -->

                      <td class="place" :rowspan="`${schedule.rowspan}`" v-if="item === 1">
                        <div>
                          <span class="name">{{ schedule.name }}</span>
                          <!-- <span class="type text-style-2 text-sub-color">{{ schedule.type }}</span> -->
                          <a v-if="cinema && schedule.photo" @click="index = (seatingPhotos.findIndex(item => item.url === schedule.photo))" class="seating-img-btn" :style="`color: ${cinema.mainColor}`">座席表 ></a>
                        </div>
                      </td>
                      <template v-for="(slot, k) in schedule.slots">
                      <td style="padding-bottom: 10px;" class="slot" v-if="k >= (item - 1) * 5 && k < item * 5" :key="k">
                        <h2>{{ slot.start }}</h2>
                        <p>{{ slot.end }}</p>
                        <!-- version tag -->
                        <div class="info-list" style="margin-bottom: 10px;">
                          <label v-if="slot.type" class="info">{{slot.type}}</label>
                          <label v-if="slot.version2 && slot.version2 !== 'なし'" :class="['info', slot.version2 === '字幕' ? 'SUB' : 'DUB']">{{slot.version2}}</label>
                          <label class="info" v-for="(str, idx) in slot.version3" :key="idx">{{str}}</label>
                        </div>
                        <!-- <a v-if="slot.isSalesOpen" :href="`${slot.href}`">
                          <button class="purchase-button" :style="`background-color: ${slot.buttonColor}`">{{ getBtnText(slot) }}</button>
                        </a>
                        <div class="no-purchase" v-else></div> -->
                      </td>
                      </template>
                      <template v-if="item === Math.ceil(schedule.slots.length / 5) && (schedule.slots.length % 5) !== 0">
                      <td v-for="idx in (5 - schedule.slots.length % 5)" class="slot" :key="`movie-${idx}-schedule-${idx}-empty-slot-${j}`"></td>
                    </template>
                      <!-- <td v-for="k in (schedule.slots.length)" class="slot" :key="`movie-${idx}-schedule-${j}-empty-slot-${k}`"></td> -->
                    </tr>
                  </tbody>
                  </table>
                  </div>
                  </div>
                  <vue-gallery-slideshow :images="seatingPhotos" :index="index" @close="index = null"></vue-gallery-slideshow>
                </div>
              </template>
              <template v-else>
                <template v-for="(schedule, idx) in movies[swiperIndex].schedules">
                  <div v-for="(slot, j) in schedule.slots" :key="`schedule-${idx}-slot-${j}`" class="movie-schedule-info flex-row">
                    <div class="time">
                      <h2>{{ slot.start }}</h2>
                      <p>{{ slot.end }}</p>
                    </div>
                    <div class="room">
                      <p class="name text-sub-color">{{ schedule.name }}</p>
                      <!-- <p class="type text-sub-color">{{ slot.type }}</p> -->
                    </div>
                    <!-- version tag -->
                    <div class="info-list" style="margin-bottom: 10px;">
                      <label v-if="slot.type" class="info">{{slot.type}}</label>
                      <label v-if="slot.version2 && slot.version2 !== 'なし'" :class="['info', slot.version2 === '字幕' ? 'SUB' : 'DUB']">{{slot.version2}}</label>
                      <label class="info" v-for="(str, idx) in slot.version3" :key="idx">{{str}}</label>
                    </div>
                    <!-- <div class="purchase">
                      <a v-if="slot.isSalesOpen" :href="`${
                        slot.buttonText === '✕ 満席' ? 'javascript:void(0);': slot.href
                      }`">
                        <button class="purchase-button" :style="`background-color: ${slot.buttonColor}`">
                          {{ slot.buttonText }}
                          {{ getBtnText(slot) }}
                        </button>
                      </a>
                    </div> -->
                  </div>
                </template>
              </template>
            </div><!-- mobile version hide -->
            <Empty v-else type="film"></Empty>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
// import BannerNews from '../../components/bannerNews/BannerNews'
// import News from '../../components/news/News'
// import Address from '../../components/address/Address'
import CalendarHead from '../../components/calendarHead/CalendarHead'
import MovieSwiper from '../../components/movieSwiper/MovieSwiper'
import Empty from '../../components/empty/Empty'
import { ApiService } from '@/services/api.service'
import VueGallerySlideshow from 'vue-gallery-slideshow'
import _ from 'lodash'
import { getBtnText } from '../../services/util'
export default {
  name: 'IndexPage',

  components: {
    // BannerNews,
    // News,
    // Address,
    CalendarHead,
    MovieSwiper,
    Empty,
    VueGallerySlideshow
  },

  data () {
    return {
      isLoading: false,
      windowWidth: null,
      tagFilter: [
        { value: 'all', label: this.$i18n.messages[this.$i18n.fallbackLocale].news.allLabel },
        { value: 'importantNotice', label: '重要なお知らせ' },
        { value: 'notice', label: 'お知らせ' },
        { value: 'activity', label: 'イベント' },
        { value: 'send', label: '配信' },
        { value: 'campaign', label: 'キャンペーン' }
      ],
      newsList: [],
      movies: [],
      swiperIndex: 0,
      address: {
        name: 'Tollywood',
        location: '東京都世田谷区代沢5-32-5-2F',
        tel: '03-3414-0433',
        email: '1234567@gmail.com'
      },
      index: null,
      getBtnText
    }
  },
  computed: {
    place () {
      return encodeURI(this.address.location + ' ' + this.address.name)
    },
    mobileWidth () {
      return this.$store.state.dom.widthSmall
    },
    cinema () {
      return this.$store.state.cinema.cinema
    },
    seatingPhotos () {
      const result = []
      this.movies.forEach(movie => movie.schedules.forEach(schedule => {
        result.push({
          url: schedule.photo,
          alt: schedule.name
        })
      }))

      return result
    },
    housePhotos () {
      const result = this.cinema.houseList.map(item => item.housePhoto) || []
      return result
    }
  },
  methods: {
    // fetchNews () {
    //   ApiService.listNewsByOrganisationAndDate('all', 'all').then(res => {
    //     this.newsList = res.content.map(news => {
    //       return {
    //         ...news,
    //         image: this.getNewsImage(this.base64Decode(news.content)),
    //         content: this.getNewsText(this.base64Decode(news.content)),
    //         tag: [this.categoryDisplay(news.category)]
    //       }
    //     })
    //   }).catch(error => {
    //     console.error(error.response)
    //     this.dataError = true
    //   })
    // },
    routerToBuy (url, isRouter, text) {
      if (isRouter && text !== '✕ 満席') {
        window.location.href = url
      }
    },
    categoryDisplay (category) {
      const item = this.tagFilter.find(item => item.value === category)
      return item ? item.label : ''
    },
    htmlToElements (html) {
      return new DOMParser().parseFromString(html, 'text/html')
    },
    getNewsImage (content) {
      const images = this.htmlToElements(content).getElementsByTagName('img')
      if (images.length) {
        return images[0].getAttribute('src')
      }
      return null
    },
    getNewsText (content) {
      const text = this.htmlToElements(content).getElementsByTagName('p')
      if (text.length) {
        return text[0].innerText
      }
      return content
    },
    base64Decode (encodedString = '') {
      try {
        return decodeURIComponent(escape(window.atob(encodedString)))
      } catch (e) {
        console.error(e)
      }
      return encodedString
    },
    updateSelectedMovie (index) {
      this.swiperIndex = index
    },
    updateWindowWidth () {
      this.windowWidth = window.innerWidth
    },
    onDateChange (date) {
      this.fetchMovieListByDate(date)
      // turn on loading
      this.isLoading = true
    },
    parseShowList (data, date) {
      const movieList = data.map(movie => {
        const { movieDetail, houseList } = movie
        const { movieId, movieName, stillsUrl, genres, durationMin } = movieDetail
        let total = 0
        let scheduleArr = []
        const movieItem = {
          id: movieId,
          text: movieName,
          image: stillsUrl.length ? stillsUrl[0] : null,
          tag: genres,
          time: durationMin,
          category: movieDetail.category,
          schedules: houseList.map(house => {
            const { houseName, housePhoto, versions, showList } = house
            total += Math.ceil(showList.length / 5)
            return {
              name: houseName,
              type: versions,
              photo: housePhoto,
              slots: showList.map(show => {
                const { showId, startTime, endTime, ticketingUrl, version, congestionStatus, colorCode, purchasable } = show
                const StartHour = moment(startTime).utc().zone(-9).date() === moment(date).date() ? moment(startTime).utc().zone(-9).hour() : (moment(startTime).utc().zone(-9).hour() < 7 ? moment(startTime).utc().zone(-9).hour() + 24 : moment(startTime).utc().zone(-9).hour())
                const EndHour = moment(startTime).utc().zone(-9).date() === moment(date).date() ? moment(endTime).utc().zone(-9).hour() : (moment(startTime).utc().zone(-9).hour() < 7 ? moment(endTime).utc().zone(-9).hour() + 24 : moment(endTime).utc().zone(-9).hour())
                return {
                  id: showId,
                  isSalesOpen: purchasable,
                  // start: moment(startTime).format('HH:mm'),
                  start: `${StartHour}:${moment(startTime).format('mm')}`,
                  // end: moment(endTime).format('HH:mm'),
                  end: `${EndHour}:${moment(endTime).format('mm')}`,
                  // status: this.getShowStatus(show),
                  href: ticketingUrl,
                  type: version,
                  // // version2
                  // version2,
                  // version3,
                  // // version3
                  buttonColor: colorCode,
                  buttonText: congestionStatus
                }
              }),
              rowspan: Math.ceil(showList.length / 5)
            }
          }),
          needSpan: total
        }
        houseList.map(house => {
          const { showList } = house
          total += Math.ceil(showList.length / 5)

          scheduleArr = [...scheduleArr, ...this.versionCut(house, date)]
        })

        movieItem.needSpan = total
        movieItem.schedules = scheduleArr
        return movieItem
      })
      return movieList
    },
    versionCut (data, date) {
      const versionList = []
      const scheduleArr = []

      data.showList.map(item => {
        const { startTime, endTime, purchasable } = item
        const StartHour = moment(startTime).utc().zone(-9).date() === moment(date).date() ? moment(startTime).utc().zone(-9).hour() : (moment(startTime).utc().zone(-9).hour() < 7 ? moment(startTime).utc().zone(-9).hour() + 24 : moment(startTime).utc().zone(-9).hour())
        const EndHour = moment(startTime).utc().zone(-9).date() === moment(date).date() ? moment(endTime).utc().zone(-9).hour() : (moment(startTime).utc().zone(-9).hour() < 7 ? moment(endTime).utc().zone(-9).hour() + 24 : moment(endTime).utc().zone(-9).hour())
        const trItem = {
          id: item.showId,
          // isSalesOpen: moment().isBetween(moment(item.startSalesTime), moment(item.stopSalesTime), 'second'),
          isSalesOpen: purchasable,
          // start: moment(startTime).format('HH:mm'),
          start: `${StartHour}:${moment(startTime).format('mm')}`,
          // end: moment(endTime).format('HH:mm'),
          end: `${EndHour}:${moment(endTime).format('mm')}`,
          // status: this.getShowStatus(item),
          href: item.ticketingUrl,
          type: item.version,
          version2: item.version2,
          version3: item.version3,
          buttonColor: item.colorCode,
          buttonText: item.congestionStatus
        }

        if (versionList.indexOf(item.version) >= 0) {
          scheduleArr[versionList.indexOf(item.version)].slots.push(trItem)
        } else {
          versionList.push(item.version)
          scheduleArr.push({
            name: data.houseName,
            type: item.version,
            photo: data.housePhoto,
            slots: [trItem],
            rowspan: Math.ceil(data.showList.length / 5)
          })
        }
      })

      return scheduleArr
    },
    fetchMovieListByDate (date) {
      ApiService.listByDomainAndDate(this.$route.query.webKey, date).then(res => {
        // turn off loading
        this.isLoading = false
        this.movies = this.parseShowList(res, date)
        this.movies.forEach(item => {
          let number = 0
          item.schedules.forEach(schedule => {
            item.scheduleNumber = number += schedule.slots.length
          })
        })
        this.movies = _.sortBy(this.movies, [function (o) {
          return -o.scheduleNumber
        }])
      }).catch(error => {
        // turn off loading
        this.isLoading = false
        console.error(error.response)
        this.dataError = true
      })
    }
  },
  mounted () {
    this.windowWidth = window.innerWidth
    window.addEventListener('resize', this.updateWindowWidth)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.updateWindowWidth)
  },
  created () {
    // this.fetchNews()
    this.fetchMovieListByDate(moment().format('YYYY-MM-DD'))
  }
}
</script>

<style lang="scss" scoped>
  .home {
    .home-inner {
      h2.title {
        margin: 70px 0 20px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        a {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          font-size: 16px;
          font-weight: 600;
          font-stretch: normal;
          font-style: normal;
          line-height: normal;
          letter-spacing: 0.72px;
          color: var(--Secondary-font-color);
          text-decoration: none;

          span {
            margin-left: 7px;

            .chevron {
              border-color: var(--Secondary-font-color);
            }
          }

          @include media_mobile {
            display: none;
          }
        }

        &.news-title {
          margin-top: 40px;

          @include media_mobile {
            justify-content: center;
            margin: 0;
            padding: 5px 0 10px;
          }
        }

        @include media_mobile {
          margin: 0;
          padding: 5px 0 10px;
          font-weight: 600;
          line-height: normal;
          letter-spacing: 0.81px;
        }
      }

      .movie-container {
        .movie-schedule {
          .movie-schedule-head {
            border: 0 solid;
            border-radius: 3px;
            box-shadow: 0 0 12px 0 rgba(0, 0, 0, 0.08);
            background-color: var(--Card-background-color);

            .movie-schedule-info {
              display: none;

              h2 {
                font-size: 18px;
                font-weight: 500;
                line-height: normal;
                letter-spacing: 0.81px;
                margin-top: 10px;
              }

              .info {
                background-color: rgba(22, 23, 27, 0.6);
                margin-top: 5px;
              }

              a.more-anchor {
                display: flex;
                justify-content: center;
                align-items: center;
                font-size: 10px;
                font-weight: 600;
                line-height: normal;
                letter-spacing: 0.45px;
                color: var(--Secondary-font-color);
                text-decoration: none;

                span {
                  margin-left: 7px;

                  .chevron {
                    border-color: var(--Secondary-font-color);
                  }
                }
              }

              @include media_mobile {
                display: block;
              }
            }

            .calendar-head {
              @include media_mobile {
                border: solid 1px $color-grey-7;
                margin-top: 10px;
              }
            }

            @include media_mobile {
              margin: 0 -10px;
              width: calc(100% + 20px);
              box-shadow: none;
             //border: solid 1px $color-grey-7;
            }
          }

          .loader, .loader:after {
            border-radius: 50%;
            width: 10em;
            height: 10em;
          }
          .loader {
            margin: 60px auto;
            font-size: 10px;
            position: relative;
            text-indent: -9999em;
            border-top: 1.1em solid rgba(255, 255, 255, 0.2);
            border-right: 1.1em solid rgba(255, 255, 255, 0.2);
            border-bottom: 1.1em solid rgba(255, 255, 255, 0.2);
            border-left: 1.1em solid #9e9e9e;
            -webkit-transform: translateZ(0);
            -ms-transform: translateZ(0);
            transform: translateZ(0);
            -webkit-animation: load8 1.1s infinite linear;
            animation: load8 1.1s infinite linear;
          }
          @-webkit-keyframes load8 {
            0% {
              -webkit-transform: rotate(0deg);
              transform: rotate(0deg);
            }
            100% {
              -webkit-transform: rotate(360deg);
              transform: rotate(360deg);
            }
          }
          @keyframes load8 {
            0% {
              -webkit-transform: rotate(0deg);
              transform: rotate(0deg);
            }
            100% {
              -webkit-transform: rotate(360deg);
              transform: rotate(360deg);
            }
          }

          .schedule-container{
            display: flex;
          }

          .movie-schedule-body {
            .movie-schedule-item {
              display: block;
              flex-direction: row;
              flex-wrap: nowrap;
              justify-content: space-between;
              margin-top: 10px;
              width: 100%;
              padding: 15px;
              border: 0 solid;
              border-radius: 3px;
              box-shadow: 0 0 12px 0 rgba(0, 0, 0, 0.08);
              background-color: var(--Card-background-color);

              > h2 {
                margin-bottom: 15px;
                display: flex;
                justify-content: space-between;
                align-items: center;

                a {
                  display: flex;
                  justify-content: flex-start;
                  align-items: center;
                  font-size: 16px;
                  font-weight: 600;
                  font-stretch: normal;
                  font-style: normal;
                  line-height: normal;
                  letter-spacing: 0.72px;
                  color: var(--Secondary-font-color);
                  text-decoration: none;

                  span {
                    margin-left: 7px;

                    .chevron {
                      border-color: var(--Secondary-font-color);
                    }
                  }
                }
              }

              .schedule {
                width: 100%;
                height: unset;
              }

              .schedule-table {
                width: 100%;
                height: 100%;
                border-collapse: collapse;
                border: 1px $color-grey-2 solid;

                td {
                  border: 1px $color-grey-2 solid;
                  width: calc(100% / 914 * 748 / 6);
                  height: 90px;
                  vertical-align: middle;

                  &.place {
                    background-color: rgba(67, 67, 67, 0.1);
                    vertical-align: middle;

                    div {
                      display: flex;
                      flex-direction: column;
                      justify-content: center;
                      align-items: center;
                      height: 100%;

                      span.name {
                        font-size: 16px;
                        font-weight: 500;
                        letter-spacing: 0.72px;
                        margin-bottom: 5px;
                        text-align: center;
                      }

                      a {
                        margin-top: 12px;
                        font-size: 10px;
                        font-weight: 500;
                        color: $color-pink-2;
                      }

                      .seating-img-btn {
                        &:hover {
                          cursor: pointer;
                        }
                      }
                    }
                  }

                  &.slot {
                    padding: 5px 15px 0;
                    text-align: center;
                    vertical-align: middle;

                    p {
                      font-size: 16px;
                      font-weight: 500;
                      line-height: normal;
                      letter-spacing: 0.72px;
                      color: var(--Secondary-font-color);
                    }

                    .purchase-button {
                      min-width: 80px;
                      border: 0 solid;
                      border-radius: 3px;
                      // color: var(--Button-font-color);
                      font-size: 14px;
                      font-weight: 500;
                      line-height: normal;
                      letter-spacing: 0.63px;
                      padding: 2px 15px;
                    }

                    .no-purchase {
                      height: 24px;
                    }

                    &.warning {
                      .purchase-button {
                        background-color: $color-orange-2;
                      }
                    }

                    &.occupy {
                      .purchase-button {
                        background-color: $color-red-1;
                      }
                    }
                  }
                }
              }
            }

            .image {
                    width: calc(100% / 914 * 166);
                    height: inherit;
                    padding-right: 10px;
                    margin: auto;

                    img {
                      width: 100%;
                    }

                    &.full-height {
                      height: 180px;

                      img {
                        height: calc(100% - 25px);
                        width: auto;
                      }
                    }
                  }

            .movie-schedule-info {
              align-items: center;
              padding: 15px 0;
              border-bottom: 1px solid $color-grey-7;

              .time {
                width: 80px;

                p {
                  color: var(--Secondary-font-color);
                }
              }

              .room {
                flex: 1;
              }

              .purchase {

              }

              .purchase-button {
                min-width: 80px;
                background-color: $color-green-1;
                border: 0 solid;
                border-radius: 3px;
                // color: var(--Button-font-color);
                font-size: 14px;
                font-weight: 500;
                line-height: normal;
                letter-spacing: 0.63px;
                padding: 2px 15px;
              }

              &.warning {
                .purchase-button {
                  background-color: $color-orange-2;
                }
              }

              &.occupy {
                .purchase-button {
                  background-color: $color-red-1;
                }
              }

              &.expired {
                h2 {
                  color: var(--Secondary-font-color);
                }
              }
            }
          }
        }

        .movie-swiper {
          display: none;
          margin: 0 -10px;
          width: calc(100% + 20px);
          background-color: var(--Background-color);

          @include media_mobile {
            display: block;
          }
        }

        @include media_mobile {
          background-color: var(--Card-background-color);
          box-shadow: 0 0 12px 0 rgba(0, 0, 0, 0.08);
          padding: 0 10px 10px;
        }
      }
    }

    @include media_mobile {
      background-color: var(--Background-color);
      margin-top: 44px;
    }
  }
</style>
